import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { ILaboratoryProjects } from "./routeType";

import type { IPickMutation } from "@/api";
import { getApi } from "@api/apiPath";
import { axiosClient, queryClient } from "@api/clients.ts";
import { useGetAllMemberLaboratoryProjects } from "@/api/members/laboratories/projects/getAll";
import { useGetMemberLaboratoryProject } from "@/api/members/laboratories/projects/get";

const { getPath } = getApi("members.laboratories.projects.post");

type IExtractedRouteType = ILaboratoryProjects["laboratoryProjectSingleCreate"];

export type IPostMemberLaboratoryProject = IPickMutation<IExtractedRouteType>;

const postMemberLaboratoryProject: MutationFunction<
  IPostMemberLaboratoryProject["response"],
  IPostMemberLaboratoryProject["variables"]
> = ({ labId, ...data }) => {
  return axiosClient.post(getPath({ labId }), data);
};

export const usePostMemberLaboratoryProject = createMutation({
  mutationFn: postMemberLaboratoryProject,
  onSuccess: (_, { labId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberLaboratoryProjects.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberLaboratoryProject.getKey({ labId }),
    });
  },
});
